import ServerResponseError from "./ServerResponseError";

export default class ServerAuthError extends Error {
    private readonly _code: number;
    protected readonly _type: string = 'ServerAuthError';

    constructor(message: string, code: number = 500) {
        super(message);

        this._code = code;

        Object.setPrototypeOf(this, ServerResponseError.prototype);
    }

    public get code() {
        return this._code;
    }

    public get type() {
        return this._type;
    }
}
